// extracted by mini-css-extract-plugin
export default {"pizzaSize":"PizzaSize_pizzaSize__yL5+1","active":"PizzaSize_active__LhGj4"};